// removed by extract-text-webpack-plugin
module.exports = {"container":"_3tf5pV4d9d2QYfaKbBLWLS","content":"tMa80sOeA7NRmQD-0XWeb","head":"_1JltXFz2tMthg0jqi3Mzfe","freelanceName":"_3eqJPYJIF-I1KtSz-r5wQg","label":"_2pKm-RuNPLmfTcscssURYR","titleTop":"_3ad-B2MbDDKJiwXCLXjZ8y","blockInfo":"_2fz-Yb4KuB4oEfa1-p9JUi","block":"_3rDpnQ64Pkr9f_WMHLOUCV","address":"_3JMpY5hMI_T_Y7yvYxNjYz","preview":"_1tNSoSwykoHqrz6DG9v0Xp","btnRemove":"_3DRMOS1rN3VNSKNNTfUS2w","removeLabel":"UJBE9MRe4oHoNn511X6XO","dash":"_3JcJ3Z3yT5unZzeCLnymg4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Booking/BookingRequestDetail.scss
// module id = 1093
// module chunks = 0